var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[(_vm.tokenIsValid)?_c('submit-form',{attrs:{"is-edit":true,"member-id":_vm.memberId,"prefill":_vm.prefill,"readonly":true},on:{"submit":_vm.submitForm}}):_vm._e(),_c('FormDialog',{attrs:{"success":_vm.success},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }